var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectPackage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.5 0L43.8594 7.39002L58.279 14.72L43.8594 22.11L29.5 29.5L15.1405 22.11L0.720947 14.72L15.1405 7.39002L29.5 0Z",
    fill: "#D9AC80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4021 6.72852L45.1811 21.4485L42.5976 22.7703L13.8186 8.05031L16.4021 6.72852Z",
    fill: "#F2D3BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.279 44.2808V14.7207L43.8595 22.1107L29.5 29.5007V59.0007L58.279 44.2808Z",
    fill: "#A67E4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1559 27.3993L47.885 24.0948C48.9064 23.6141 50.108 23.9746 50.4685 24.9359C50.829 25.8972 50.2883 27.0989 49.2669 27.6396L42.5979 30.9441C41.5765 31.4247 40.3748 31.0642 40.0143 30.1029C39.5938 29.1416 40.1345 27.8799 41.1559 27.3993Z",
    fill: "#643513"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5 59.0007V29.5007L15.1405 22.1107L0.720947 14.7207V44.2808L29.5 59.0007Z",
    fill: "#926E43"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59,
    height: 59,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectPackage);
export default __webpack_public_path__ + "static/media/select-package.087181a8a965d01ad75b197cd19dd069.svg";
export { ForwardRef as ReactComponent };